export default {
    routes: [
      {
        path: '/baseimovel',
        component: () => import('./components/BaseImovel.vue')
      }
    ]
};
